import { Space, Modal,Typography } from "antd";
import {
  CheckCircleOutlined,
  LoadingOutlined,
  RightOutlined,
} from "@ant-design/icons";
import "./RecruitmentQuestionMembershipCard.scss";
import { useEffect, useState } from "react";
import httpclient from "../../../service/httpclient";
const { Paragraph } = Typography;
function Description() {
  return (
    <div className="recruitment-question-membership-card-description">
      <div>
        <Space>
          <CheckCircleOutlined style={{ color: "rgb(103, 117, 245)" }} />
          解锁所有提单
        </Space>
      </div>
      <div>
        <Space>
          <CheckCircleOutlined style={{ color: "rgb(103, 117, 245)" }} />
          会员模拟考试
        </Space>
      </div>
      <div>
        <Space>
          <CheckCircleOutlined style={{ color: "rgb(103, 117, 245)" }} />
          秋招新题速达
        </Space>
      </div>
      <div>
        <Space>
          <CheckCircleOutlined style={{ color: "rgb(103, 117, 245)" }} />
          更多福利...
        </Space>
      </div>
    </div>
  );
}

function RecruitmentQuestionMembershipCard(hasMembership) {
  const [productMembership, setProductMembership] = useState(null);
  const [promotionCode,setPromotionCode] = useState('');
  useEffect(() => {
    httpclient.getOneProductMembership(1).then((res) => {
      setProductMembership(res);
    }, []);
    if(hasMembership){
        httpclient.getProductMembershipPromoitonCode().then(res =>{
            setPromotionCode(res?.promotion_code)
        })
    }
  }, []);

  if(!hasMembership){
      return (
          <div className="recruitment-question-membership-card">
              <div className="recruitment-question-membership-card-title">
                  <b style={{ fontSize: 18, flexShrink: 0 }}>题库Pro会员</b>
                  {productMembership ? (
                      <Space style={{ flexShrink: 0 }} align="baseline">
            <span>
              <b style={{ fontSize: 20 }}>
                ¥{productMembership.calculated_price / 100}
              </b>
            </span>
                          <span>
              {productMembership.calculated_price !==
              productMembership.price && (
                  <del>¥{productMembership.price / 100}</del>
              )}
                              /年
            </span>
                      </Space>
                  ) : (
                      <LoadingOutlined />
                  )}
              </div>

              <Description />

              <div
                  className="recruitment-question-membership-card-button"
                  type="primary"
                  onClick={() =>
                      window.open(
                          "/info/product_membership/1",
                          "_blank",
                          "noopener,noreferrer"
                      )
                  }
              >
                  <b style={{ fontSize: 16 }}>
                      <Space>
                          前往了解
                          <RightOutlined />
                      </Space>
                  </b>
              </div>
          </div>
      );
  }else{
      return (
          <div className="recruitment-question-membership-card">
              <div className="recruitment-question-membership-card-title">
                  <b style={{ fontSize: 18, flexShrink: 0 }}>题库Pro会员</b>
                  <b>邀请新人加入享优惠</b>
              </div>

              <div style={{padding: '10px 20px 0 20px',  color: 'rgb(80, 80, 80)', fontSize:'14px'}}>
                  好友使用您专属优惠码购买，可以立享70元优惠<br/>
                  好友购买后您将获得专栏半价优惠券一张，专栏50元优惠券各一张
              </div>

              <div
                  className="recruitment-question-membership-card-button"
                  type="primary"
                  onClick={() =>
                      Modal.info({
                          title:"个人专属优惠码",
                          content:
                              <div>
                                  <div style={{display:'flex'}}>
                                      优惠码:<Paragraph copyable>{promotionCode}</Paragraph>
                                  </div>
                                  <div style={{fontSize:'12px',color:'grey',marginTop:'20px'}}>注：请复制优惠码并发送给您的好友，好友在购买时可以输入此优惠码享70元优惠。购买成功后，您可获得专栏半价券一张，专栏50元代金券一张。</div>
                              </div>,
                          okType: "primary",
                          okText: "确定",
                      })
                  }
              >
                  <b style={{ fontSize: 16 }}>
                      <Space>
                          邀请好友
                          <RightOutlined />
                      </Space>
                  </b>
              </div>
          </div>
      );
  }
}

export default RecruitmentQuestionMembershipCard;
